document.addEventListener('DOMContentLoaded', function () {
  console.log('[GSM] PRICES JS LOADED');

  function all(sel) {
    const nodes = Array.from(document.querySelectorAll(sel));
    console.log('[GSM] select', sel, '=>', nodes.length, 'nodes');
    return nodes;
  }

  function setAll(nodes, text) {
    console.log('[GSM] setAll', nodes.length, 'nodes to', text);
    nodes.forEach(function (el) {
      el.textContent = text;
    });
  }

  function money(v) {
    return (
      '$' +
      Number(v).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    );
  }

  const goldOzEls     = all('[data-gsm-gold-oz]');
  const goldGrEls     = all('[data-gsm-gold-g]');
  const goldStatusEls = all('[data-gsm-gold-status]');

  const silverOzEls     = all('[data-gsm-silver-oz]');
  const silverGrEls     = all('[data-gsm-silver-g]');
  const silverStatusEls = all('[data-gsm-silver-status]');

  const platOzEls     = all('[data-gsm-plat-oz]');
  const platGrEls     = all('[data-gsm-plat-g]');
  const platStatusEls = all('[data-gsm-plat-status]');

  const gramsPerOunce = 31.1034768;

  async function loadPrices() {
    try {
      console.log('[GSM] calling worker...');

      const res = await fetch(
        'https://gsm-prices.comblocmarket.workers.dev/?t=' + Date.now(),
        { cache: 'no-store' }
      );

      console.log('[GSM] worker status', res.status);
      if (!res.ok) throw new Error('HTTP ' + res.status);

      const data = await res.json();
      console.log('[GSM] worker data', data);

      const gold   = Number(data.gold);
      const silver = Number(data.silver);

      const platRaw = data.platinum != null ? Number(data.platinum) : null;
      let plat = null;

      if (platRaw && isFinite(platRaw) && platRaw > 0) {
        plat = platRaw < 10 ? 1 / platRaw : platRaw;
      }

      console.log('[GSM] parsed numbers', { gold, silver, platRaw, plat });

      // GOLD
      if (isFinite(gold)) {
        setAll(goldOzEls, money(gold));
        setAll(goldGrEls, money(gold / gramsPerOunce));
        setAll(goldStatusEls, 'live');
      } else {
        setAll(goldOzEls, 'N/A');
        setAll(goldGrEls, 'N/A');
        setAll(goldStatusEls, 'offline');
      }

      // SILVER
      if (isFinite(silver)) {
        setAll(silverOzEls, money(silver));
        setAll(silverGrEls, money(silver / gramsPerOunce));
        setAll(silverStatusEls, 'live');
      } else {
        setAll(silverOzEls, 'N/A');
        setAll(silverGrEls, 'N/A');
        setAll(silverStatusEls, 'offline');
      }

      // PLATINUM
      if (isFinite(plat)) {
        setAll(platOzEls, money(plat));
        setAll(platGrEls, money(plat / gramsPerOunce));
        setAll(platStatusEls, 'live');
      } else {
        setAll(platOzEls, 'N/A');
        setAll(platGrEls, 'N/A');
        setAll(platStatusEls, 'offline');
      }
    } catch (err) {
      console.error('[GSM] Price fetch failed:', err);

      setAll(goldOzEls, 'N/A');
      setAll(goldGrEls, 'N/A');
      setAll(goldStatusEls, 'offline');

      setAll(silverOzEls, 'N/A');
      setAll(silverGrEls, 'N/A');
      setAll(silverStatusEls, 'offline');

      setAll(platOzEls, 'N/A');
      setAll(platGrEls, 'N/A');
      setAll(platStatusEls, 'offline');
    }
  }

  // Initial load
  loadPrices();

  // Refresh every 60 seconds
  setInterval(loadPrices, 60_000);

  // Shopify dynamic section hooks
  document.addEventListener('shopify:section:load', loadPrices);
  document.addEventListener('shopify:section:reorder', loadPrices);
  document.addEventListener('shopify:section:select', loadPrices);
  document.addEventListener('shopify:section:deselect', loadPrices);
});


// Hide default page title on the Estate page only
document.addEventListener('DOMContentLoaded', function () {
  var path = window.location.pathname.replace(/\/+$/, '');

  if (path === '/pages/estate') {
    var title = document.querySelector('.page-inner > h1.page-title');
    if (title) title.style.display = 'none';
  }
});
